import React from 'react'

const Consumer = () => {
    return (
        <div>Consumer</div>
    )
}

export default Consumer